export const EntityRequestInit = {
    entityApplicationId: 0,
    entityDescription: "",
    entityName: "",
};
